(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("lodash"), require("prop-types"), require("@fiverr/i18n/singleton"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "lodash", "prop-types", "@fiverr/i18n/singleton", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["SeoSubCategory"] = factory(require("react"), require("lodash"), require("prop-types"), require("@fiverr/i18n/singleton"), require("react-dom"));
	else
		root["SeoSubCategory"] = factory(root["React"], root["_"], root["PropTypes"], root["i18n"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_Jmof__, __WEBPACK_EXTERNAL_MODULE_PbPb__, __WEBPACK_EXTERNAL_MODULE_T9WB__, __WEBPACK_EXTERNAL_MODULE_h4G9__, __WEBPACK_EXTERNAL_MODULE_wLXD__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition